import React from 'react';

const ChildMultiSelect = ({ familyChildren = [], childrenMap = {}, selectedChildIds = [], onChange }) => {
  if (!familyChildren.length) return null;

  const toggle = (childId) => {
    if (selectedChildIds.includes(childId)) {
      onChange(selectedChildIds.filter(id => id !== childId));
    } else {
      onChange([...selectedChildIds, childId]);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-ink mb-1.5">For which children</label>
      <div className="flex flex-wrap gap-2">
        {familyChildren.map(child => {
          const isSelected = selectedChildIds.includes(child.id);
          const color = childrenMap[child.id]?.color || child.color || '#8b5cf6';
          return (
            <button
              key={child.id}
              type="button"
              onClick={() => toggle(child.id)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
                isSelected
                  ? 'text-white shadow-sm'
                  : 'bg-white border border-fog/30 text-ink/70 hover:border-fog/50'
              }`}
              style={isSelected ? { backgroundColor: color } : undefined}
            >
              {!isSelected && (
                <span
                  className="w-2 h-2 rounded-full flex-shrink-0"
                  style={{ backgroundColor: color }}
                />
              )}
              {child.firstName}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChildMultiSelect;
